module.exports = __webpack_public_path__ + "mo.ca730b9b468da930bdba.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mo.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mo.svg
// module chunks = styles